<div id="printContainer" #printContainer style="visibility: hidden;">
    <div class="report-header" *ngIf="report">
        <div class="rh-left">
            <div class="rh-sub">
                BAER ACCOMPLISHMENT REPORT
            </div>
            <div class="rh-title">
                <h1 class="rh-title-h1">{{report.report_name}}</h1>
            </div>
        </div>
    </div>
    <div class="report-main" *ngIf="report">
        <div class="report-right-area">
            <div class="report-area">
                <div class="report-section">
                    <app-view-accomplishment-details [report]="report" [reportList]="reportList" [(nav)]="nav"
                        (status)="statusChange($event)" (loaded)="subLoaded($event)"
                        *ngIf="reportList"></app-view-accomplishment-details>
                    <app-view-accomplishment-treatments [report]="report" [reportList]="reportList" [(nav)]="nav"
                        (status)="statusChange($event)" (loaded)="subLoaded($event)"
                        *ngIf="reportList"></app-view-accomplishment-treatments>
                    <app-view-accomplishment-additional [report]="report" [reportList]="reportList" [(nav)]="nav"
                        [currentUser]="currentUser" (status)="statusChange($event)" (loaded)="subLoaded($event)"
                        *ngIf="reportList"></app-view-accomplishment-additional>
                </div>
            </div>
        </div>
    </div>
</div>